import axios from 'axios';

import { push } from 'connected-react-router';
import { AnyAction } from 'redux';
import { call, put } from 'redux-saga/effects';

import {
  calculateUfAmountFromPlan,
  cleanRut,
  formatDateToIsoString,
  generateUUID,
  hashData,
  parserRut,
  planCharacteristics,
  planChargesTitle,
} from '../helpers/utils';
import { RESET_STATE, showError } from './Commons';

export const URL_QUOTE = '/quote';
export const SET_QUOTE_FORM = 'QUOTEFORM/SET';
export const SUBMIT_QUOTE_FORM = 'QUOTE/SUBMIT';
export const SET_QUOTE = 'QUOTE/SET';
export const QUOTING = 'QUOTING';
export const FAIL_QUOTING = 'QUOTING/FAIL';
export const SELECT_PLAN = 'QUOTE/SELECT';
export const SET_PLAN = 'PLAN/SELECT';
export const SET_UUID = 'UUID/SET';
export const SET_HASH = 'HASH/SET';

export interface IPlan {
  name: string;
  planName: string;
  plan_id: string;
  premium_monthly: number;
  premium_monthly_CLP: number;
  premium_annual: number;
  companyId: string;
  companyName: string;
}

export interface IQuoteForm {
  birthdate: string;
  charges: string;
  email: string;
  phone: string;
  documentId: string;
}

export interface IQuote {
  id: number;
  consecutive: number;
  branch: number;
  plansWithConsultation: any[];
  plansWithoutConsultation: any[];
}

export const setQuoteForm = (payload: IQuoteForm) => ({
  payload,
  type: SET_QUOTE_FORM,
});

export const setQuote = (payload: IQuote) => ({
  payload,
  type: SET_QUOTE,
});

export const submitQuote = (payload: IQuoteForm) => ({
  payload,
  type: SUBMIT_QUOTE_FORM,
});

export const quoting = () => ({
  type: QUOTING,
});

export const selectedPlan = (payload: IPlan) => ({
  payload,
  type: SELECT_PLAN,
});

export const setSelectedPlan = (payload: IPlan) => ({
  payload,
  type: SET_PLAN,
});

export const failQuoting = () => ({
  type: FAIL_QUOTING,
});

export const setUUID = (payload: string) => ({
  payload,
  type: SET_UUID,
});

export const setHASH = (payload: string) => ({
  payload,
  type: SET_HASH,
});

const initialState = {
  data: {
    birthdate: '',
    charges: '0',
    documentId: '',
    email: '',
    phone: '',
  },
  planSelected: {},
  quote: {
    branch: 0,
    consecutive: 0,
    control: '',
    id: 0,
    plansWithConsultation: [],
    plansWithoutConsultation: [],
  },
  submitting: false,
  uuid: '',
  hashClientId: '',
};

export default function quoteReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_QUOTE_FORM:
      return {
        ...state,
        data: action.payload,
      };
    case QUOTING:
      return {
        ...state,
        submitting: true,
      };
    case FAIL_QUOTING:
      return {
        ...state,
        submitting: false,
      };
    case SET_QUOTE:
      return {
        ...state,
        quote: action.payload,
        submitting: false,
      };
    case SET_PLAN:
      return {
        ...state,
        planSelected: action.payload,
      };
    case SET_UUID:
      return {
        ...state,
        uuid: action.payload,
      };
    case SET_HASH:
      return {
        ...state,
        hashClientId: action.payload,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function* doQuote({ payload }: AnyAction) {
  try {
    yield put(quoting());
    yield put(setQuoteForm(payload));
    const formattedDate = formatDateToIsoString(
      payload.birthdate,
      'DD-MM-YYYY',
    );
    const { documentId, ...restPayload } = payload;
    const quoteRequest = {
      branch: '8681',
      channel: 'INTERNET',
      executive: '33285',
      payload: {
        insured: {
          document: {
            number: parserRut(documentId),
            type: 'RUT',
          },
          ...restPayload,
          birthdate: formattedDate,
          phone: `+56${restPayload.phone}`,
        },
      },
    };
    const uuid = generateUUID();
    const hashClientId = `CL_RUT_${hashData(`${cleanRut(documentId)}`)}`;
    const config = {
      headers: {
        transactionId: uuid,
        hashClientId,
      },
    };
    const { data } = yield call(axios.post, URL_QUOTE, quoteRequest, config);

    const plansResponse = data.plans.map((plan: any) => ({
      ...plan,
      ...planCharacteristics[plan.properties.id],
      amount: calculateUfAmountFromPlan(plan.properties.id),
      charges: planChargesTitle[payload.charges],
      image: plan.company.image,
    }));

    const plansWithConsultation = plansResponse.filter(
      (plan: any) => plan.consultation,
    );
    const plansWithoutConsultation = plansResponse.filter(
      (plan: any) => !plan.consultation,
    );

    const quoteResponse = {
      ...data,
      plansWithConsultation,
      plansWithoutConsultation,
    };

    yield put(push('/plans'));
    yield put(setUUID(uuid));
    yield put(setHASH(hashClientId));
    yield put(setQuote(quoteResponse));
  } catch (error) {
    yield put(failQuoting());
    yield put(showError());
  }
}

export function* selectPlan({ payload }: AnyAction) {
  yield put(setSelectedPlan(payload));
  yield put(push('/emit'));
}
